<template>
  <section class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row gutter="20">
            <el-col :lg="14" :xl="14">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li
                  v-if="
                    selectedCaseIds.length &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    auto-insert-space
                    @click="onPrintBarCodes"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/printer-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/printer-icon-black.svg"
                        alt="icon"
                      />
                    </span>
                    <span>PRINT BARCODE</span>
                  </el-button>
                </li>
                <li
                  v-if="
                    !selectedCaseIds.length &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    @click="generateBarcodesDialogVisible = true"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/new-barcode-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/new-barcode-icon.svg"
                        alt="icon"
                      />
                    </span>
                    <span>GENERATE BARCODE</span>
                  </el-button>
                </li>
                <li
                  v-if="
                    selectedCaseIds.length &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    auto-insert-space
                    @click="onPrintQrCodes"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/print_barcode_white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/print_barcode.svg"
                        alt="icon"
                      />
                    </span>
                    <span>PRINT QRCODE</span>
                  </el-button>
                </li>
                <li
                  v-if="
                    !selectedCaseIds.length &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    @click="generateQrcodesDialogVisible = true"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/print_barcode_white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/print_barcode.svg"
                        alt="icon"
                      />
                    </span>
                    <span>GENERATE QRCODE</span>
                  </el-button>
                </li>
                <li
                  v-if="
                    checkDLWLab &&
                    !selectedCaseIds.length &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    @click="generateTestBarcodesDialogVisible = true"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/test_barcode_white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/test_barcode.svg"
                        alt="icon"
                      />
                    </span>
                    <span> TEST BARCODES</span>
                  </el-button>
                </li>
                <li
                  v-if="
                    selectedCaseIds.length &&
                    checkDLWLab &&
                    hasPermission('generate_barcode', 'view')
                  "
                >
                  <el-button
                    class="btn button-with-icon"
                    auto-insert-space
                    @click="onPrintTestBarCodes"
                  >
                    <span class="mr-5">
                      <img
                        src="@/assets/images/test_barcode_white.svg"
                        alt="icon"
                        class="active"
                      />
                      <img
                        class="inactive"
                        src="@/assets/images/test_barcode.svg"
                        alt="icon"
                      />
                    </span>
                    <span>PRINT TESTBARCODES</span>
                  </el-button>
                </li>
                <li>
                  <div
                    class="form-element input-with-icon search-input-lg w-200"
                  >
                    <el-input
                      placeholder="Accession / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="10" :xl="10">
              <ul class="d-flex justify-content-end list-items-group-15 w-90">
                <li v-if="searchBy === 'Priority' && this.priority">
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="fromDate"
                      type="date"
                      placeholder="From Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      :disabled-date="(date) => date > new Date()"
                      @change="toDate && handleCurrentChange(1)"
                      value-format="YYYY-MM-DD"
                      style="width: 100%"
                    />
                  </div>
                </li>
                <li v-if="searchBy === 'Priority' && this.priority">
                  <div class="search-with-date-input">
                    <el-date-picker
                      v-model="toDate"
                      type="date"
                      placeholder="To Date"
                      format="MM-DD-YYYY"
                      :clearable="true"
                      value-format="YYYY-MM-DD"
                      :disabled-date="(date) => date > new Date()"
                      style="width: 100%"
                      @change="handleCurrentChange(1)"
                    />
                  </div>
                </li>

                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                  >
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                      @clear="clearSearchBy"
                      @focus="initializeSearchOptions"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </li>

                <li v-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchAllCases()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'Priority'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="priority"
                      placeholder="Select Priority"
                      filterable
                      :clearable="true"
                      default-first-option
                      @clear="clearTest"
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="priority in casePriorityTypes"
                        :key="priority"
                        :label="priority.name"
                        :value="priority.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'emr'">
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search EMR NO"
                      v-model="emr"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'patient_name'">
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search Patient"
                      v-model="patient_name"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'accession_id'">
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search Accession ID"
                      v-model="accession_id"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'test_performed_by'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="test_performed_by"
                      placeholder="Select User"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllUsers"
                      :loading="userLoading"
                    >
                      <el-option
                        v-for="(user, index) in usersList"
                        :key="index"
                        :label="user.first_name + ' ' + user.last_name"
                        :value="user._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital_marketers'">
                  <div class="form-element search-with-filter-input marketers">
                    <el-select
                      v-model="hospital_marketer"
                      placeholder="Select Sales Rep"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllUsers"
                      :loading="userLoading"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="(user, index) in marketerData"
                        :key="index"
                        :label="user.first_name + ' ' + user.last_name"
                        :value="user._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="hospital"
                      placeholder="Select Ordering Facility"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      remote
                      :remote-method="remoteMethodFacility"
                      :loading="hospitalLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                      :loading="physicianLoading"
                      remote
                      :remote-method="remoteMethodPhysician"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="physician.name"
                        :value="physician._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'case_types'">
                  <div
                    class="form-element search-with-filter-input"
                    v-if="
                      getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                      getAuthenticatedUser.allowed_case_types
                    "
                  >
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      @clear="clearTest"
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChangeCaseType(1)"
                    >
                      <el-option
                        v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                  <div class="form-element search-with-filter-input" v-else>
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @clear="clearTest"
                      :reserve-keyword="false"
                      @change="handleCurrentChangeCaseType(1)"
                    >
                      <el-option
                        v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>

                <li v-if="caseType && caseType.length">
                  <div
                    v-if="
                      caseType && caseType.length && caseType === 'TOXICOLOGY'
                    "
                    class="form-element search-with-filter-input trigger-drowpdown"
                  >
                    <el-select
                      v-model="test_info"
                      placeholder="Select Test Id"
                      filterable
                      clearable
                      multiple
                      collapse-tags
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleTest(1)"
                    >
                      <el-option
                        v-for="test in this.testIds"
                        :key="test"
                        :label="test.category"
                        :value="test.tests"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div
                    class="form-element search-with-filter-input trigger-drowpdown"
                    v-else
                  >
                    <el-select
                      v-model="test_info"
                      placeholder="Select Test Id"
                      filterable
                      clearable
                      multiple
                      collapse-tags
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleTest(1)"
                    >
                      <el-option
                        v-for="test in this.testIds"
                        :key="test"
                        :label="test.category"
                        :value="test.tests"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </li>
                <li v-else-if="searchBy == 'billing_sub_status'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="billing_sub_status"
                      placeholder="Select Exception"
                      default-first-option
                      :reserve-keyword="false"
                      filterable
                      clearable
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="category in this.exceptionCategoriesMap"
                        :key="category"
                        :label="category"
                        :value="category"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onReportsExport"
                    title="
                        Minimum One Filter is Required
                    "
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllCases.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
            @selection-change="handleSelectionChange($event)"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column
              fixed="left"
              width="35"
              v-if="isFacilityUser || isUserLab"
            >
              <template #default="scope">
                <span
                  v-if="
                    scope.row.is_critical &&
                    scope.row.is_abnormal &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/red-alert-icon.svg"
                    style="width: 16px; margin-top: 7px"
                    alt="icon"
                    title="Contains critical values"
                  />
                </span>
                <span
                  v-else-if="
                    scope.row.is_critical &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/red-alert-icon.svg"
                    style="width: 16px; margin-top: 7px"
                    alt="icon"
                    title="Contains critical values"
                  />
                </span>
                <span
                  v-else-if="
                    scope.row.is_abnormal &&
                    scope.row.test_reports &&
                    scope.row.test_reports.length
                  "
                >
                  <img
                    src="@/assets/images/orange-alert-icon.svg"
                    style="width: 16px; margin-top: 7px"
                    alt="icon"
                    title="Contains abnormal values"
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="140"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession" style="display: flex">
                  <span
                    id="accession-id"
                    @click="goToCaseView(scope.row._id)"
                    style="margin-right: 2px"
                  >
                    {{ scope.row.accession_id }}
                    <span
                      v-if="isPhlebioUser"
                      :style="
                        scope.row.Priority === 'STAT'
                          ? 'color: red; font-weight: 600;'
                          : ''
                      "
                    >
                      {{
                        scope.row.Priority === "STAT"
                          ? "- " + scope.row.Priority
                          : ""
                      }}
                    </span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              prop="case_types"
              min-width="135px"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div
                  v-else-if="
                    scope.row.case_types && scope.row.case_types.length == 1
                  "
                  class="case-type"
                >
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
                <div v-else></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="140"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" min-width="100">
              <template #default="scope">
                <span style="cursor: default" v-if="scope.row.patient_info">
                  {{
                    scope.row.patient_info.date_of_birth
                      ? formatDate(scope.row.patient_info.date_of_birth)
                      : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="ordering_facility"
              label="ORDERING FACILITIES"
              min-width="215"
              class="ordering_facility"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Physician" min-width="120">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes('Dr')
                        ? scope.row.ordering_physician.name
                        : 'Dr ' + scope.row.ordering_physician.name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.name.includes("Dr")
                          ? scope.row.ordering_physician.name
                          : "Dr " + scope.row.ordering_physician.name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Collected On"
              min-width="135"
              prop="collection_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.collection_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="125"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Status"
              width="130"
              sortable="custom"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status cursor" v-if="scope.row.status">
                  <el-dropdown
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeStatus(command, scope.row, scope.$index)
                    "
                    trigger="hover"
                    v-if="
                      hasPermission('cases', 'update_status') &&
                      scope.row.status &&
                      scope.row.status != 'ARCHIVED'
                    "
                    :disabled="scope.row.status === 'ARCHIVED'"
                  >
                    <span class="el-dropdown-link">
                      <el-tag :type="getStatusType(scope.row.status)">
                        {{
                          scope.row.status === "COMPLETE"
                            ? "FINALIZED"
                            : scope.row.status === "TEST_REPORTS"
                            ? "PROCESSING"
                            : scope.row.status.split("_").join(" ")
                        }}
                      </el-tag>
                    </span>

                    <template
                      #dropdown
                      v-if="scope.row.status && scope.row.status == 'REJECTED'"
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="ACTIVE"
                          :disabled="scope.row.status === 'ACTIVE'"
                          >ACTIVE</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        scope.row.status &&
                        (scope.row.status == 'COMPLETE' ||
                          scope.row.status == 'TEST_REPORTS')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="TEST_REPORTS"
                          :disabled="scope.row.status === 'TEST_REPORTS'"
                          >PROCESSING</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="COMPLETE"
                          :disabled="scope.row.status === 'COMPLETE'"
                          >FINALIZED</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                    <template
                      #dropdown
                      v-else-if="
                        scope.row.status &&
                        (scope.row.status == 'ACTIVE' ||
                          scope.row.status == 'INITIATE')
                      "
                    >
                      <el-dropdown-menu class="status-dropdown-menu">
                        <!-- For non-CLINICAL_CHEMISTRY case types -->
                        <el-dropdown-item
                          v-if="
                            !scope.row.case_types.includes('CLINICAL_CHEMISTRY')
                          "
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>

                        <!-- For CLINICAL_CHEMISTRY with 1 category -->
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            scope.row.status !== 'REJECTED' &&
                            !hasMoreThanOneUniqueCategoryCode(
                              scope.row.test_panel_id
                            )
                          "
                          command="REJECTED"
                          :disabled="scope.row.status === 'REJECTED'"
                        >
                          REJECTED
                        </el-dropdown-item>

                        <!-- For CLINICAL_CHEMISTRY with > 1 category -->
                        <el-dropdown-item
                          v-if="
                            scope.row.case_types.includes(
                              'CLINICAL_CHEMISTRY'
                            ) &&
                            scope.row.status !== 'REJECTED' &&
                            hasMoreThanOneUniqueCategoryCode(
                              scope.row.test_panel_id
                            )
                          "
                          command="NOT_TO_CALL"
                        >
                          <span
                            class="view-button"
                            title="Reject"
                            @click="rejectTests(scope.row)"
                          >
                            REJECTED
                          </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <el-tag
                    v-else-if="isFacilityUser"
                    :type="getStatusType(scope.row.status)"
                  >
                    {{
                      !isBillingUser && scope.row.status === "TEST_REPORTS"
                        ? "PROCESSING"
                        : scope.row.status === "COMPLETE" &&
                          scope.row.release == false
                        ? "ACTIVE"
                        : scope.row.priliminary_report_generated === true &&
                          scope.row.status == "ACTIVE"
                        ? "PRELIMINARY"
                        : scope.row.status === "COMPLETE"
                        ? "FINALIZED"
                        : scope.row.status === "ARCHIVED"
                        ? "ARCHIVED"
                        : scope.row.status === "ACTIVE"
                        ? "ACTIVE"
                        : scope.row.status === "REJECTED"
                        ? "REJECTED"
                        : scope.row.status === "TEST_REPORTS"
                        ? "ACTIVE"
                        : "PROCESSING"
                    }}</el-tag
                  >
                  <el-tag v-else :type="getStatusType(scope.row.status)">
                    <span v-if="scope.row.status === 'TEST_REPORTS'"
                      >PROCESSING</span
                    >
                    <span v-else-if="scope.row.status === 'COMPLETE'"
                      >FINALIZED</span
                    >
                    <span v-else>{{
                      scope.row.status.split("_").join(" ")
                    }}</span>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REJECTED REASONS"
              width="300"
              v-if="$route.path === '/all-cases/rejected'"
            >
              <template #default="{ row }">
                <div class="name-accession cursor">
                  <el-tooltip
                    v-if="row.reasons && row.reasons.length > 0"
                    effect="dark"
                    placement="top"
                  >
                    <template #content>
                      {{ row.reasons.join(", ") }}
                    </template>
                    <span id="accession-id-blue" class="truncate-text">
                      {{ row.reasons.join(", ") }}
                    </span>
                  </el-tooltip>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REASON FOR HOLD"
              width="300"
              v-if="this.$route.path === '/all-cases/release-pending'"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <el-tooltip
                    placement="bottom"
                    :content="
                      scope.row.release_notes
                        ? scope.row.release_notes.includes(
                            'No payable codes found for case type'
                          )
                          ? scope.row.release_notes.replace(
                              'No payable codes found for case type',
                              'Un-related ICD codes for'
                            )
                          : scope.row.release_notes
                        : ''
                    "
                  >
                    <span id="accession-id-blue">
                      {{
                        scope.row.release_notes
                          ? scope.row.release_notes.includes(
                              "No payable codes found for case type"
                            )
                            ? scope.row.release_notes.replace(
                                "No payable codes found for case type",
                                "Un-related ICD codes for"
                              )
                            : scope.row.release_notes
                          : "--"
                      }}
                    </span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Reported On"
              min-width="125"
              prop="reported_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.reported_at" class="d-flex">
                  <div style="cursor: default" class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.reported_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Order/EMR/PHLEBIO" width="180">
              <template #default="scope">
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.order_id"
                >
                  <span
                    id="accession-id-blue"
                    @click="sendParameter(scope.row)"
                  >
                    {{ scope.row.order_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  v-if="scope.row && scope.row.emr_order"
                >
                  <span
                    id="accession-id-blue"
                    @click="viewEMR(scope.row.emr_order)"
                  >
                    {{ scope.row.emr_reference_id }}
                  </span>
                </div>
                <div
                  class="name-accession cursor"
                  v-if="
                    scope.row &&
                    scope.row.phlebio_order_id &&
                    scope.row.phlebio_order_id.Phlebio_Order_id
                  "
                >
                  <span
                    id="accession-id-blue"
                    @click="viewPhlebioOrder(scope.row.phlebio_order_id._id)"
                  >
                    {{ scope.row.phlebio_order_id.Phlebio_Order_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Results"
              width="180"
              v-if="hasToxicologyCaseType || showToxColumn"
            >
              <template #default="scope">
                <div
                  class="column-status"
                  v-if="scope.row.status == 'COMPLETE'"
                >
                  <div class="date pr-10">
                    <el-tag :type="getCovidStatusType(resultStatus(scope.row))">
                      {{ resultStatus(scope.row) }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ ORDER STATUS"
              min-width="180"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <el-button
                  type="text"
                  class="btn-synced cursor-test"
                  v-if="scope.row.labdaq_order_status"
                >
                  {{ scope.row.labdaq_order_status }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ REPORT STATUS"
              min-width="210"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <el-button
                  v-if="
                    hasBloodCaseType(scope.row) &&
                    scope.row.labdaq_order_status == 'SENT' &&
                    scope.row.labdaq_report_status == 'PENDING'
                  "
                  type="text"
                  class="btn-sync"
                  @click="syncLabdaqReports(scope.row._id)"
                  >Sync</el-button
                >
                <el-button
                  type="text"
                  class="btn-processing"
                  v-if="
                    scope.row.labdaq_order_status == 'SENT' &&
                    scope.row.labdaq_report_status == 'ERROR'
                  "
                  @click="syncLabdaqReports(scope.row._id)"
                  >Re-Sync</el-button
                >
                <span v-else>
                  <el-button
                    type="text"
                    class="btn-synced cursor-test"
                    v-if="
                      hasBloodCaseType(scope.row) &&
                      scope.row.labdaq_order_status == 'SENT' &&
                      scope.row.labdaq_report_status == 'SYNCED'
                    "
                  >
                    SYNCED
                  </el-button>
                </span>
                <span>
                  <el-button
                    type="text"
                    class="view-button"
                    v-if="
                      hasBloodCaseType(scope.row) &&
                      scope.row.status === 'TEST_REPORTS' &&
                      scope.row.labdaq_report_status == 'SYNCED'
                    "
                    @click="syncLabdaqReports(scope.row._id)"
                  >
                    <img
                      class="action-active"
                      src="@/assets/img/icons/regenerate.svg"
                      alt="icon"
                    />
                  </el-button>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="LABDAQ REPORT MESSAGE"
              min-width="210"
              prop="reported_at"
              v-if="
                !isFacilityUser &&
                checkLab &&
                (hasClinicalChemistry || showClinicalColumn)
              "
            >
              <template v-slot="scope">
                <span>{{ scope.row.labdaq_report_message }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Results"
              prop="covid_status"
              sortable="custom"
              width="150"
              v-if="hasCovidCaseType || hasCovidColumns"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    v-if="
                      hasCovid(scope.row) &&
                      scope.row.covid_status &&
                      hasPermission('cases', 'update_covid_status')
                    "
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeCovidStatus(
                          command,
                          scope.row._id,
                          scope.$index,
                          scope.row.covid_status
                        )
                    "
                    trigger="click"
                  >
                    <span class="el-dropdown-link">
                      <el-tag
                        v-if="scope.row.covid_status != 'RESULT_AWAITED'"
                        :type="getCovidStatusType(scope.row.covid_status)"
                      >
                        {{ scope.row.covid_status }}
                      </el-tag>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item command="POSITIVE"
                          >POSITIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="NEGATIVE"
                          >NEGATIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="INCONCLUSIVE"
                          >INCONCLUSIVE</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <span
                    v-else-if="hasCovid(scope.row) && scope.row.covid_status"
                  >
                    <el-tag
                      v-if="
                        scope.row.covid_status &&
                        scope.row.covid_status != 'RESULT_AWAITED'
                      "
                      :type="getCovidStatusType(scope.row.covid_status)"
                    >
                      {{ scope.row.covid_status }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Results"
              width="180"
              v-if="hasUtiRppCase || showResultColumn"
            >
              <template #default="scope">
                <div
                  class="column-status"
                  v-if="scope.row.status == 'COMPLETE'"
                >
                  <div class="date pr-10">
                    <el-tag
                      :type="getCovidStatusType(reportResultStatus(scope.row))"
                    >
                      {{ reportResultStatus(scope.row) }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ARCHIVE REASON"
              width="300"
              v-if="
                hasPermission('cases', 'attachments') &&
                this.$route.path === '/all-cases/archive'
              "
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span id="accession-id-blue">
                    {{
                      scope.row.archive_reason ? scope.row.archive_reason : "--"
                    }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              :width="isSuperAdmin ? '230' : '220'"
              fixed="right"
            >
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('cases', 'create_new') &&
                      isBillingUser
                    "
                  >
                    <div v-if="scope.row.emr_order">
                      <el-button
                        class="view-button"
                        title="Concurrent Case"
                        @click="
                          goToConcurrentCase(
                            'CONCURRENT CASE WITH EMR',
                            scope.row._id
                          )
                        "
                      >
                        <img
                          class="action-active"
                          src="@/assets/images/icons/actions/concurrent-case-active.svg"
                          alt="icon"
                        />
                        <img
                          class="action-inactive"
                          src="@/assets/images/icons/actions/concurrent-case-inactive.svg"
                          alt="icon"
                        />
                      </el-button>
                    </div>
                    <div v-else>
                      <el-button
                        class="view-button"
                        title="Concurrent Case"
                        @click="
                          goToConcurrentCase('CONCURRENT CASE', scope.row._id)
                        "
                      >
                        <img
                          class="action-active"
                          src="@/assets/images/icons/actions/concurrent-case-active.svg"
                          alt="icon"
                        />
                        <img
                          class="action-inactive"
                          src="@/assets/images/icons/actions/concurrent-case-inactive.svg"
                          alt="icon"
                        />
                      </el-button>
                    </div>
                  </li>
                  <li
                    @click="onRestore(scope.row._id)"
                    v-if="scope.row.status == 'ARCHIVED'"
                  >
                    <el-button class="view-button" title="Restore">
                      <img
                        class="action-active"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/img/icons/regenerate.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status == 'ACTIVE' &&
                      hasPermission('send_outs', 'create')
                    "
                  >
                    <el-button
                      class="reports-button"
                      @click="goToSendOutReports(scope.row._id)"
                      :disabled="checkSendOutDisable(scope.row)"
                      :title="
                        checkSendOutDisable(scope.row)
                          ? 'Sendout Already Created'
                          : 'Sendout'
                      "
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/sendouts-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/sendouts-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('cases', 'delete') &&
                      scope.row.status == 'ACTIVE'
                    "
                  >
                    <el-button
                      title="Archive"
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/archive-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/archive-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.is_labdaq_order == true &&
                      scope.row.status !== 'COMPLETE' &&
                      scope.row.status !== 'ARCHIVED' &&
                      scope.row.case_types &&
                      scope.row.case_types.indexOf('CLINICAL_CHEMISTRY') !==
                        -1 &&
                      hasPermission('cases', 'create_case') &&
                      !isFacilityUser &&
                      checkLab
                    "
                  >
                    <el-button
                      v-if="scope.row.labdaq_order_status == 'SENT'"
                      title="Resend To Labdaq"
                      class="delete-button"
                      @click="sentToLabdaq(scope.row._id)"
                    >
                      <img
                        class="inactive"
                        src="@/assets/images/resend-order.svg"
                        alt="icon"
                      />
                    </el-button>
                    <el-button
                      v-else
                      title="Send To Labdaq"
                      class="delete-button"
                      @click="sentToLabdaq(scope.row._id)"
                    >
                      <img
                        class="inactive"
                        src="@/assets/images/send-order.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.status == 'COMPLETE' &&
                      (isFacilityUser || hasPermission('cases', 'create_case'))
                    "
                  >
                    <el-button
                      title="View Report"
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                    >
                      <span
                        class="beforeTestReportsIcon"
                        v-if="
                          checkNewReport(scope.row) &&
                          checkCaseStatus(scope.row)
                        "
                      >
                        <img
                          src="@/assets/images/icons/actions/beforeViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                      <span class="afterTestReportsIcon" v-else>
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                  <li
                    v-else-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.priliminary_report_generated == true &&
                      hasPermission('cases', 'preliminary_report')
                    "
                  >
                    <el-button
                      title="View Report"
                      class="reports-button"
                      @click="onViewPriliminaryReports(scope.row)"
                    >
                      <span
                        class="beforeTestReportsIcon"
                        v-if="scope.row.priliminary_report_viewed == false"
                      >
                        <img
                          src="@/assets/images/icons/actions/beforeViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                      <span class="afterTestReportsIcon" v-else>
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                  <li v-if="hasPermission('cases', 'archive_cases')">
                    <el-button
                      title="Move To Validation"
                      class="reports-button validation-button"
                      @click="moveToValidations(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/validation-new-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/validation-new-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      hasPermission('cases', 'archive_cases')
                    "
                  >
                    <el-button
                      title="Archive"
                      class="delete-button"
                      @click="onDelete(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/archive-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/archive-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      hasPermission('orders', 'create') && scope.row.order_id
                    "
                  >
                    <el-button
                      @click="reOrder(scope.row.order)"
                      title="Re-Order"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/re-order-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/re-order-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    @click="gotoPatientResultsTrendToxiclogy(scope.row)"
                    v-if="
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types &&
                      scope.row.case_types[0] == 'TOXICOLOGY'
                    "
                  >
                    <el-button class="view-button" title="PATIENT RESULTS">
                      <img
                        src="@/assets/images/icons/actions/trends-icon-new.svg"
                        alt="icon"
                        style="width: 18px"
                      />
                    </el-button>
                  </li>
                  <li
                    @click="gotoPatientResultsTrendClinicalChemistry(scope.row)"
                    v-if="
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types &&
                      scope.row.case_types[0] == 'CLINICAL_CHEMISTRY' &&
                      checkColonyLab
                    "
                  >
                    <el-button class="view-button" title="PATIENT RESULTS">
                      <img
                        src="@/assets/images/icons/actions/trends-icon-new.svg"
                        alt="icon"
                        style="width: 18px"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      isResultPositive(scope.row) &&
                      scope.row.status == 'COMPLETE' &&
                      scope.row.case_types[0] == 'UTI' &&
                      hasPermission('cases', 'report_upload_new') &&
                      isAbletoGeneratePathologyReport
                    "
                  >
                    <el-button
                      class="action-download"
                      @click="generatePathologyReport(scope.row)"
                      title="Generate Pathology Report"
                    >
                      <span>
                        <img
                          src="@/assets/images/icons/actions/restore-icon.svg"
                          alt="icon"
                          class="img-fluid"
                        />
                      </span>
                    </el-button>
                  </li>
                  <li
                    @click="onDownloadPathologyReport(scope.row)"
                    v-if="
                      scope.row.status == 'COMPLETE' &&
                      scope.row.pathology_report_path &&
                      !isBillingUser
                    "
                  >
                    <el-button
                      class="view-button"
                      title="DONWLOAD PATHOLOGY REPORT"
                    >
                      <img
                        class="testreports-active"
                        src="@/assets/images/icons/Download_2.svg"
                        alt="icon"
                        style="width: 22px"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getAllCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="default-modal">
      <div v-if="generateBarcodesDialogVisible">
        <el-dialog
          top="10%"
          width="35%"
          v-model="generateBarcodesDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Barcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateBarcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="barcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="barcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateBarcodes"
                  :disabled="isDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <!-- Select Tests to Reject popup -->
    <TestsRejectPopup
      :showRejectTestPopup="showRejectTestPopup"
      :groupedTests="groupedTests"
      :selectedTests="selectedTests"
      :selectedPanels="selectedPanels"
      :formData="formData"
      :loading="loading"
      :rejectCaseError="rejectCaseError"
      :isRejectButtonDisabled="isRejectButtonDisabled"
      :predefinedReasons="predefinedReasons"
      @close-popup="closeIconRejectPopup"
      @update-individual-test="updateIndividualTest"
      @select-panel-tests="selectPanelTests"
      @update-reasons="(val) => (formData.selectedReasons = val)"
      @update-notes="updateNotes"
      @form-validated="rejectSelectedTests"
    />

    <div class="default-modal">
      <div v-if="generateQrcodesDialogVisible">
        <el-dialog top="10%" width="35%" v-model="generateQrcodesDialogVisible">
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Qrcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateQrcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="qrcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="qrcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateQrcodes"
                  :disabled="isQrDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <div class="default-modal">
      <el-dialog top="10%" width="35%" v-model="errorMessage">
        <div class="dialog-header">
          <span class="header-part"> Error </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="errorMessage = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date">
          <h3 class="messageData">{{ this.messageData }}</h3>
        </div>
        <div class="popup-date">
          {{ this.testDetailsData }}
        </div>
      </el-dialog>
    </div>
    <div class="default-modal">
      <div v-if="generateTestBarcodesDialogVisible">
        <el-dialog
          top="10%"
          width="35%"
          v-model="generateTestBarcodesDialogVisible"
        >
          <div class="dialog-header">
            <span class="header-part">
              <img
                src="@/assets/images/new-barcode-icon-blue.svg"
                alt="icon"
              />Generate Barcodes
            </span>
            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="generateTestBarcodesDialogVisible = false"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>

          <el-row :gutter="20" class="popup-date">
            <el-col :lg="8" :xl="9">
              <span class="date-label">From Date</span>
              <el-date-picker
                type="date"
                v-model="test_barcode_receive_from_date"
                placeholder="From Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="9">
              <span class="date-label">To Date</span>
              <el-date-picker
                type="date"
                v-model="test_barcode_receive_to_date"
                placeholder="To Date"
                format="MM-DD-YYYY"
                :disabled-date="disabledDate"
                value-format="YYYY-MM-DD"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="8" :xl="6">
              <div class="dialog-footer mt-15">
                <el-button
                  class="blue-save-button"
                  @click="onSelectedDatesGenerateTestBarcodes"
                  :disabled="isTestDateAvailable"
                >
                  GENERATE</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
    <ExportCases
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :selected_dob="date_of_birth"
      :selected_case_type="caseType"
      :selected_hospital="[hospital]"
      :selected_user="test_performed_by"
      :selected_marketer="hospital_marketer"
      :selected_tests="test_info"
      :selected_physician="physician"
      :selected_string="search_string"
      :selected_emr="emr"
      :selected_accession_id="accession_id"
      :search_case_status="selectedStatuses"
      :search_first_name="patient_name"
      :pregnancy="pregnant"
      :sendout="sendout"
      :emr_not_sent="emr_not_sent"
      :selected_exception="billing_sub_status"
      :replaced_insurance="replaced_insurance"
      :priority="priority"
      :fromDate="fromDate"
      :toDate="toDate"
    >
    </ExportCases>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="deleteCase"
      title="Reason for Archive"
    ></ResonForChange>
    <ResonForStatusChange
      v-if="takeStatusChangeReasonDialog"
      v-on:close="takeStatusChangeReasonDialog = false"
      v-on:reasonSubmit="unsetCaseCompleteStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    >
    </ResonForStatusChange>
    <ResonForValidation
      v-if="takeValidationReasonDialog"
      v-on:close="takeValidationReasonDialog = false"
      v-on:reasonSubmit="moveToValidation"
      title="Reason for Validation"
    ></ResonForValidation>
    <ReasonForStatusMoving
      v-if="takeStatusMovingReasonDialog"
      v-on:close="takeStatusMovingReasonDialog = false"
      v-on:reasonSubmit="unsetCaseMovingStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    >
    </ReasonForStatusMoving>
    <div class="default-modal">
      <el-dialog
        v-model="regenerateOrder"
        width="30%"
        :before-close="handleClose"
        title="Re Order"
        v-loading="loading"
      >
        <div class="export-dialog-header">
          <div class="export-header-part pl-1r">
            <h3>Re Order</h3>
          </div>

          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handleClose"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date pb-0">
          <div class="reorder-radio">
            <el-radio-group
              v-model="reOrderWithTestInfo"
              class="re-order-radio-list"
            >
              <el-radio label="test_info">Include Test Info</el-radio>
              <el-radio label="new_test_info">New Test Info</el-radio>
            </el-radio-group>
          </div>
          <div class="reorder-radio">
            <el-radio-group
              v-model="reOrderWithAddress"
              class="re-order-radio-list"
            >
              <el-radio label="old_address">Include Address</el-radio>
              <el-radio label="new_address">New Address</el-radio>
            </el-radio-group>
          </div>
          <div class="reorder-radio">
            <el-radio-group
              v-model="reOrderWithInsurance"
              class="re-order-radio-list"
            >
              <el-radio label="old_insurance">Include Insurance</el-radio>
              <el-radio label="new_insurance">New Insurance</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="dialog-footer w-95">
          <el-button
            class="blue-save-button"
            :disabled="checkOptions"
            @click="reOrderCase()"
            >Submit</el-button
          >
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import {
  casesExtraSearchOptions,
  exceptionCategories,
} from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import FilterHelper from "@/mixins/FilterHelper";
import AppHelper from "@/mixins/AppHelper";
import axios from "axios";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ResonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExportCases = defineAsyncComponent(() =>
  import("@/components/cases/ExportCases")
);
const ResonForValidation = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ReasonForStatusMoving = defineAsyncComponent(() =>
  import("@/components/misc/OrderReasonForChange")
);
import TestsRejectPopup from "./TestsRejectPopup.vue";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import config from "@/config/app";
export default {
  name: "allCases",
  components: {
    ResonForChange,
    ResonForStatusChange,
    ExportCases,
    ResonForValidation,
    ReasonForStatusMoving,
    TestsRejectPopup,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
    selectedReportStatus: {
      default: false,
    },
    emr_not_sent: {
      default: false,
    },
    replaced_insurance: {
      default: false,
    },
  },
  created() {
    if (this.isFacilityUser) {
      let markerFilterIndex = this.searchOptions.findIndex(
        (option) => option.value == "hospital_marketers"
      );
      if (markerFilterIndex > -1) {
        this.searchOptions[markerFilterIndex].active = false;
      }
    }
    this.searchOptions = this.searchOptions.filter((option) => option.active);
  },
  computed: {
    ...mapGetters("cases", [
      "getUpdateCaseCovidStatus",
      "getCaseDeleteStatus",
      "getUpdateCaseStatus",
      "getRestoreCaseStatus",
      "getSendAccessionToLabdaq",
      "getSyncAccessionToLabdaq",
      "getTestReportsDownloadLog",
      "getTestReportsViewLog",
      "getSendToLabdaqValiationError",
      "getUpdateValidationStatus",
      "getDownloadReportData",
      "getGeneratePathologyReportStatus",
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserPrimaryLabId",
    ]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    isDateAvailable() {
      if (!this.barcode_receive_to_date) {
        return true;
      }
      return false;
    },
    isTestDateAvailable() {
      if (!this.test_barcode_receive_to_date) {
        return true;
      }
      return false;
    },
    isQrDateAvailable() {
      if (!this.qrcode_receive_to_date) {
        return true;
      }
      return false;
    },
    checkCaseStatus() {
      return (caseData) => {
        if (caseData.status === "COMPLETE") {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          let newReport = caseData.test_reports.find((report) => {
            if (report.download_logs) {
              let userDownloadLog = report.download_logs.find(
                (e) => e.user_id === this.getAuthenticatedUser._id
              );
              if (userDownloadLog) {
                return false;
              } else {
                return true;
              }
            }
          });
          if (newReport) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "CONSISTENT") {
          return "success";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else {
          return "nullvalue";
        }
      };
    },
    ...mapGetters("cases", ["getAllCases", "getBulkValidations"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("profile", ["getProfileData"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    hasCovidCaseType() {
      if (
        this.searchBy == "case_types" &&
        (this.caseType == "COVID" || this.caseType == "COVID_FLU")
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        (this.$route.query.selectedCase == "COVID" ||
          this.$route.query.selectedCase == "COVID_FLU")
      ) {
        return true;
      }
      return false;
    },
    hasToxicologyCaseType() {
      if (this.searchBy == "case_types" && this.caseType == "TOXICOLOGY") {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        this.$route.query.selectedCase == "TOXICOLOGY"
      ) {
        return true;
      }
      return false;
    },

    hasUtiRppCase() {
      if (
        this.searchBy == "case_types" &&
        (this.caseType == "UTI" ||
          this.caseType == "RESPIRATORY_PATHOGEN_PANEL" ||
          this.caseType == "WOUND" ||
          this.caseType == "NAIL" ||
          this.caseType == "GASTRO" ||
          this.caseType == "URINALYSIS")
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        (this.$route.query.selectedCase == "UTI" ||
          this.$route.query.selectedCase == "RESPIRATORY_PATHOGEN_PANEL" ||
          this.$route.query.selectedCase == "WOUND" ||
          this.$route.query.selectedCase == "NAIL" ||
          this.$route.query.selectedCase == "GASTRO" ||
          this.$route.query.selectedCase == "URINALYSIS")
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters("errors", ["getErrors", "getError"]),
    checkDLWLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW-TX") {
          return true;
        }
        return false;
      }
      return false;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW") {
          return true;
        }
        return false;
      }
      return false;
    },
    reportResultStatus() {
      return (status) => {
        if (status) {
          const testReportsData = status.test_reports;

          for (let i = 0; i < testReportsData.length; i++) {
            if (testReportsData[i].mark_for_physician) {
              const resultStatus = testReportsData[i].result_status;

              return resultStatus;
            }
          }

          return "--";
        }

        return "--";
      };
    },
    resultStatus() {
      return (status) => {
        if (status) {
          const testReportsData = status.test_reports;

          for (let i = 0; i < testReportsData.length; i++) {
            if (testReportsData[i].mark_for_physician) {
              const resultStatus = testReportsData[i].result_status;

              return resultStatus;
            }
          }

          return "--";
        }

        return "--";
      };
    },
    hasClinicalChemistry() {
      if (
        this.searchBy == "case_types" &&
        this.caseType == "CLINICAL_CHEMISTRY"
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        this.$route.query.selectedCase == "CLINICAL_CHEMISTRY"
      ) {
        return true;
      }
      return false;
    },
    showClinicalColumn() {
      if (this.search_string && this.getAllCases && this.getAllCases.data) {
        return this.getAllCases.data.every((item) =>
          item.case_types.every((type) => type === "CLINICAL_CHEMISTRY")
        );
      }
      return null;
    },
    checkOptions() {
      if (
        this.reOrderWithTestInfo &&
        this.reOrderWithAddress &&
        this.reOrderWithInsurance
      ) {
        return false;
      }
      return true;
    },
    isResultPositive() {
      return (status) => {
        if (status) {
          const testReportsData = status.test_reports;
          for (let i = 0; i < testReportsData.length; i++) {
            if (testReportsData[i].mark_for_physician) {
              const resultStatus = testReportsData[i].result_status;
              if (resultStatus === "POSITIVE") {
                return true;
              }
            }
          }
          return false;
        }
        return "--";
      };
    },
    isRejectButtonDisabled() {
      const hasSelectedTests = Object.keys(this.selectedTests).length > 0;
      const hasSelectedPanels = Object.values(this.selectedPanels).some(
        Boolean
      );
      const hasReasons =
        Array.isArray(this.formData.selectedReasons) &&
        this.formData.selectedReasons.length > 0;
      const hasValidNotes =
        typeof this.formData.notes === "string" &&
        this.formData.notes.trim().length >= 3;

      // Enable button only if: (tests OR panels selected) AND reasons AND valid notes
      return (
        this.allItemsSelected ||
        !(
          (hasSelectedTests || hasSelectedPanels) &&
          hasReasons &&
          hasValidNotes
        )
      );
    },
    totalRejectableItems() {
      // Calculate total rejectable items:
      // - Panels (excluding ALL_TESTS and SEND_OUTS if they exist)
      // - Individual tests in ALL_TESTS and SEND_OUTS if they exist
      const excludedPanels = ["ALL_TESTS", "SEND_OUTS"].filter((panel) =>
        Object.keys(this.groupedTests).includes(panel)
      ).length;

      console.log(excludedPanels, "excludedPanels");
      const panelCount = Object.keys(this.groupedTests).length - excludedPanels;
      const testCount =
        (this.groupedTests["ALL_TESTS"]?.tests?.length || 0) +
        (this.groupedTests["SEND_OUTS"]?.tests?.length || 0);
      console.log(panelCount + testCount);
      return panelCount + testCount;
    },
    selectedLength() {
      const testsLength = Object.keys(this.selectedTests).length;
      const panelsLength = Object.keys(this.selectedPanels).length;
      console.log(testsLength, ":testsLength", panelsLength, ": panelsLength");
      console.log(testsLength + panelsLength, "selectedLength");
      return testsLength + panelsLength;
    },
    allItemsSelected() {
      // Check if all rejectable items are selected
      if (this.selectedLength === this.totalRejectableItems) {
        return true;
      } else {
        return false;
      }
    },
  },
  mixins: [FilterHelper, UserPermissionsHelper, AppHelper, caseDataHelper],
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      scrollPosition: null,
      groupedTests: {},
      selectedTests: {},
      selectedPanels: {},
      formData: {
        selectedReasons: [],
        notes: "",
      },
      predefinedReasons: [
        {
          value: "Insufficient sample received",
          label: "Insufficient sample received",
        },
        {
          value: "Incorrect specimen received",
          label: "Incorrect specimen received",
        },
        { value: "Turnaround time", label: "Turnaround time" },

        {
          value: "Specimen received without requisition",
          label: "Specimen received without requisition",
        },
        { value: "Early collection", label: "Early collection" },
        {
          value: "Only requisition received without sample",
          label: "Only requisition received without sample",
        },
        {
          value: "Sample has leaked in transit",
          label: "Sample has leaked in transit",
        },
        {
          value: "Hemolyzed or clotted specimen",
          label: "Hemolyzed or clotted specimen",
        },
        { value: "Invalid insurance", label: "Invalid insurance" },
        {
          value: "Inactive insurance",
          label: "Inactive insurance",
        },
        {
          value: "Invalid ICD codes",
          label: "Invalid ICD codes",
        },
        {
          label: "The date of collection is missing in the requisition",
          value: "The date of collection is missing in the requisition",
        },
        {
          label: "ICD codes are missing in the requisition",
          value: "ICD codes are missing in the requisition.",
        },
        {
          value: "The test is not marked correctly",
          label: "The test is not marked correctly",
        },
        {
          value: "Specimen and test mismatch",
          label: "Specimen and test mismatch",
        },
        {
          value: "Medications are needed",
          label: "Medications are needed",
        },
        {
          value: "Insurance details are missing",
          label: "Insurance details are missing",
        },
        {
          value: "There is a billing mismatch",
          label: "There is a billing mismatch",
        },
        // Add more predefined reasons as needed
      ],
      reasonToActionMap: {
        "Insufficient sample received":
          "Please provide a specimen with sufficient quantity for processing the test.",
        "Incorrect specimen received":
          "Please provide the correct specimen type related to the test ordered.",
        "Turnaround time":
          "Please minimize the time delay between specimen collection and specimen receipt.",
        "Specimen received without requisition":
          "Please provide the requisition form to process the testing.",
        "Only requisition received without sample":
          "Please provide the sample for test processing along with the updated requisition.",
        "Sample has leaked in transit":
          "Please provide a fresh sample to process the test.",
        "Hemolyzed or clotted specimen":
          "Please recollect the sample as it needs to be in proper condition for testing.",
        "Invalid insurance":
          "Please provide valid insurance details along with a copy of the insurance.",
        "Inactive insurance":
          "Please provide active insurance details along with a copy of the insurance.",
        "Invalid ICD codes":
          "Please provide valid ICD codes to process the test.",
        "The date of collection is missing in the requisition":
          "We need the date of collection to process the test.",
        "ICD codes are missing in the requisition":
          "Please provide the ICD code for test processing.",
        "The test is not marked correctly":
          "We need an updated requisition to process the testing.",
        "Specimen and test mismatch":
          "The specimen and requisition are incompatible.",
        "Medications are needed":
          "We require the medications for test processing.",
        "Insurance details are missing":
          "Please provide the insurance details and a copy of the insurance card.",
        "There is a billing mismatch":
          "The bill-to information is marked incorrectly.",
      },
      testIds: {},
      testNames: [],
      usersList: [],
      marketerData: [],
      marketingManagerData: [],
      generateBarcodesDialogVisible: false,
      barcode_receive_from_date: "",
      barcode_receive_to_date: "",
      generateQrcodesDialogVisible: false,
      qrcode_receive_from_date: "",
      qrcode_receive_to_date: "",
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      search_string: "",
      emr: "",
      accession_id: "",
      patient_name: "",
      date_of_birth: "",
      hospital: "",
      test_performed_by: "",
      hospital_marketer: [],
      physician: "",
      searchBy: "",
      loading: false,
      orderBy: "",
      orderType: "",
      caseType: "",
      test_info: [],
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: casesExtraSearchOptions,
      selectedCaseIds: [],
      selectedCaseId: null,
      takeReasonDialog: false,
      requestArchiveCase: "",
      takeStatusChangeReasonDialog: false,
      takeStatusMovingReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      dialogVisible: false,
      unsetCompleteStatusChangeCase: "",
      toStatus: "",
      emrOrderId: "",
      hospitalName: "",
      exportReportsDialogVisisble: false,
      hospitalsData: {},
      physiciansData: {},
      hospitalLoading: false,
      physicianLoading: false,
      userLoading: false,
      pregnant: "",
      errorMessage: false,
      messageData: "",
      testDetailsData: "",
      requestValidationCase: "",
      takeValidationReasonDialog: false,
      havingClinicalChemistry: false,
      showComponent: false,
      casesData: [],
      sendout: "",
      reOrderWithTestInfo: "",
      reOrderWithInsurance: "",
      reOrderWithAddress: "",
      regenerateOrder: false,
      reOrderId: "",
      generateTestBarcodesDialogVisible: false,
      test_barcode_receive_from_date: "",
      test_barcode_receive_to_date: "",
      exceptionCategoriesMap: exceptionCategories,
      billing_sub_status: "",
      showToxColumn: false,
      hasCovidColumns: false,
      showResultColumn: false,
      fromDate: "",
      toDate: "",
      priority: "",
      casePriorityTypes: caseConstants.CASE_PROIROTY_TPYES,
      showRejectTestPopup: false,
      rejectCaseError: "",
    };
  },

  async mounted() {
    const versionHandled = localStorage.getItem("versionHandled");
    if (!versionHandled) {
      this.handleVersioning();
      // Set the flag in local storage to indicate that handleVersioning has been called
      localStorage.setItem("versionHandled", "true");
    }
    await this.initData();
    // Add Class to body on scroll
    window.addEventListener("Noscroll", this.onScroll);
  },
  methods: {
    updateIndividualTest(
      testId,
      isChecked,
      panelId,
      caseTypeCode,
      testName,
      testCode,
      labOrderCode,
      panelCode
    ) {
      if (isChecked) {
        this.selectedTests = {
          ...this.selectedTests,
          [testId]: {
            panel_id: panelId,
            case_type_code: caseTypeCode,
            test_name: testName,
            test_code: testCode,
            lab_order_code: labOrderCode,
            panel_code: panelCode, // ✅ added here
          },
        };
      } else {
        const updated = { ...this.selectedTests };
        delete updated[testId];
        this.selectedTests = updated;
      }
      this.checkAllItemsSelected();
    },
    hasMoreThanOneUniqueCategoryCode(testPanelData) {
      if (!testPanelData || !Array.isArray(testPanelData.panels)) return false;

      const panelCodes = testPanelData.panels
        .map((panel) => panel.panel_id?.panel_code)
        .filter(Boolean);
      const uniquePanelCodes = [...new Set(panelCodes)];

      if (uniquePanelCodes.length > 1) {
        return true;
      }

      // Only one panel code present
      if (["ALL_TESTS", "SEND_OUTS"].includes(uniquePanelCodes[0])) {
        // Flatten all test_ids arrays across ALL_TESTS or SEND_OUTS panels
        const allTests = testPanelData.panels
          .filter((panel) =>
            ["ALL_TESTS", "SEND_OUTS"].includes(panel.panel_id?.panel_code)
          )
          .flatMap((panel) => panel.test_ids || []);

        return allTests.length > 1;
      }

      return false;
    },
    selectPanelTests(panelCode, isChecked) {
      const panel = this.groupedTests[panelCode];

      if (panel) {
        if (isChecked) {
          // ✅ Select panel
          this.selectedPanels[panelCode] = true;
        } else {
          // ❌ Remove deselected panel from selectedPanels
          delete this.selectedPanels[panelCode];

          // ❌ Clear all related tests from selectedTests
          // if (panel.tests) {
          //   panel.tests.forEach(test => {
          //     delete this.selectedTests[test._id];
          //   });
          // }
        }
      } else {
        console.warn(`Panel ${panelCode} not found`);
      }
      this.checkAllItemsSelected();
    },

    async rejectTests(caseId) {
      this.caseId = caseId._id;

      this.caseId = caseId._id;

      if (caseId?.test_panel_id?.panels) {
        this.groupedTests = caseId?.test_panel_id?.panels?.reduce(
          (groups, panel) => {
            const panelCode = panel.panel_id?.panel_code || "Uncategorized";
            const panelTitle = panel.panel_id?.panel_title || panelCode;
            const panelId = panel.panel_id?._id || panelCode;
            const caseTypeCode = panel.case_type_code || "CLINICAL_CHEMISTRY";
            const labOrderCode = panel.lab_order_code || "";

            if (!groups[panelCode]) {
              groups[panelCode] = {
                title: panelTitle,
                panel_id: panelId,
                case_type_code: caseTypeCode,
                lab_order_code: labOrderCode,
                tests: [],
              };
            }

            // ✅ Enrich each test with lab_order_code, case_type_code, panel_code
            const enrichedTests = panel.test_ids.map((test) => ({
              ...test,
              lab_order_code: labOrderCode,
              case_type_code: caseTypeCode,
              panel_code: panelCode,
            }));

            groups[panelCode].tests = [
              ...groups[panelCode].tests,
              ...enrichedTests,
            ];

            return groups;
          },
          {}
        );
      } else {
        this.groupedTests = {};
      }

      this.showRejectTestPopup = true;
    },
    updateNotes() {
      const actions = this.formData.selectedReasons
        .map((reason) => this.reasonToActionMap[reason])
        .filter((action) => action);
      this.formData.notes = actions.join("\n");
    },
    closeIconRejectPopup() {
      this.rejectCaseError = "";
      this.showRejectTestPopup = false;
      this.groupedTests = {};

      this.selectedPanels = {};
      this.selectedTests = {};

      // Clear formData
      this.formData.selectedReasons = [];
      this.formData.notes = "";

      this.$nextTick(() => {
        this.$refs.ruleForm?.resetFields();
      });
    },

    async rejectSelectedTests() {
      this.rejectCaseError = "";
      this.loading = true;
      try {
        const panels = [];
        const selectedPanelCodes = Object.keys(this.selectedPanels).filter(
          (code) => this.selectedPanels[code]
        );
        const includedPanelIds = new Set();
        // ✅ Step 1: Add full panels
        for (const panelCode of selectedPanelCodes) {
          const panelData = this.groupedTests[panelCode];
          if (!panelData) continue;

          panels.push({
            panel_id: panelData.panel_id,
            case_type_code: panelData.case_type_code || "CLINICAL_CHEMISTRY",
            all_tests: true,
            test_ids: panelData.tests.map((test) => test._id),
            lab_order_code: panelData.lab_order_code || "",
          });

          includedPanelIds.add(panelData.panel_id);
        }

        // ✅ Step 2: Handle individually selected tests
        const groupedByPanel = {};

        for (const [testId, testInfo] of Object.entries(this.selectedTests)) {
          if (includedPanelIds.has(testInfo.panel_id)) continue; // Skip already handled

          if (
            testInfo.panel_code === "ALL_TESTS" ||
            testInfo.panel_code === "SEND_OUTS"
          ) {
            // ✅ Split ALL_TESTS entries into separate panel objects
            panels.push({
              panel_id: testInfo.panel_id,
              case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
              all_tests: true,
              test_ids: [testId],
              lab_order_code: testInfo.lab_order_code || "",
            });
          } else {
            // Group by panel_id normally
            if (!groupedByPanel[testInfo.panel_id]) {
              groupedByPanel[testInfo.panel_id] = {
                panel_id: testInfo.panel_id,
                case_type_code: testInfo.case_type_code || "CLINICAL_CHEMISTRY",
                all_tests: true,
                test_ids: [],
                lab_order_code: testInfo.lab_order_code || "",
              };
            }
            groupedByPanel[testInfo.panel_id].test_ids.push(testId);
          }
        }

        // ✅ Merge grouped panels (non-"ALL_TESTS") into final panels array
        panels.push(...Object.values(groupedByPanel));

        // ✅ Create tests_info
        const tests_info = panels.flatMap((panel) => panel.test_ids);

        // ✅ Final payload
        const params = {
          case_id: this.caseId,
          panels,
          tests_info,
          notes: this.formData.notes,
          reasons: this.formData.selectedReasons,
        };
        await this.$store.dispatch("rejectTestInfo/createCCRCase", params);
        if (panels.length > 0) {
          successNotification("Test rejected successfully");
        }
        window.location.reload();
        this.closeIconRejectPopup();
      } catch (error) {
        console.error("Error rejecting tests:", error);
        this.rejectCaseError = "Error Rejecting Tests";
      } finally {
        this.loading = false;
      }
    },

    checkAllItemsSelected() {
      if (this.allItemsSelected) {
        alert("DON'T Select All Tests");
      }
    },
    viewPhlebioOrder(phleboId) {
      this.$router.push({
        name: "PhlebioOrderDetails",
        params: {
          phlebio_id: phleboId,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryFacility", query);
        await this.fetchAllHospitals(query);
      }
    },
    async generatePathologyReport(report) {
      const formattedDate = moment(report.finalized_date).format(
        "MM/DD/YYYY hh:mm A"
      );

      let testResultsId;

      const testReportsData = report.test_reports;
      for (let i = 0; i < testReportsData.length; i++) {
        if (testReportsData[i].mark_for_physician) {
          testResultsId = testReportsData[i].test_results_id;
        }
      }

      this.loading = true;
      try {
        let params = {
          case_id: report._id,
          test_results_id: testResultsId,
          pathologist_date: formattedDate,
        };
        await this.$store.dispatch("cases/pathologyReport", params);
        if (this.getGeneratePathologyReportStatus) {
          successNotification("Pathology report generated successfully!");
        } else {
          errorNotification(
            this.getError || "Error while generating pathology report"
          );
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async onDownloadPathologyReport(pathologyPath) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
          path: "test_reports/" + pathologyPath.pathology_report_path,
        });
        if (
          this.getDownloadReportData &&
          this.getDownloadReportData.data &&
          this.getDownloadReportData.data.download_url
        ) {
          let url = this.getDownloadReportData.data.download_url;
          const fileStream = await axios({
            url: url,
            method: "GET",
            responseType: "blob",
          });
          const urlObject = window.URL || window.webkitURL;
          const downloadUrl = urlObject.createObjectURL(fileStream.data);
          let accessionId = pathologyPath.accession_id;
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", `${accessionId} pathology_report.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          successNotification("Pathology report downloaded successfully");
        } else if (!this.getDownloadReportData) {
          errorNotification(
            this.getError || "Error while downloading pathology report"
          );
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    updateShowToxColumn() {
      if (this.getAllCases && this.getAllCases.data) {
        this.showToxColumn = this.getAllCases.data.every((item) =>
          item.case_types.every((type) => type === "TOXICOLOGY")
        );
      } else {
        this.showToxColumn = false;
      }
    },
    updateCovidColumn() {
      if (this.getAllCases && this.getAllCases.data) {
        this.hasCovidColumns = this.getAllCases.data.every(
          (item) =>
            item.case_types.includes("COVID") ||
            item.case_types.includes("COVID_FLU")
        );
      } else {
        this.hasCovidColumns = false;
      }
    },
    updateResultColumn() {
      if (this.getAllCases && this.getAllCases.data) {
        this.showResultColumn = this.getAllCases.data.every(
          (item) =>
            item.case_types.includes("UTI") ||
            item.case_types.includes("RESPIRATORY_PATHOGEN_PANEL") ||
            item.case_types.includes("WOUND") ||
            item.case_types.includes("NAIL") ||
            item.case_types.includes("GASTRO") ||
            item.case_types.includes("URINALYSIS")
        );
      } else {
        this.showResultColumn = false;
      }
    },
    tableRowClassName({ row }) {
      if (this.getAuthenticatedUser) {
        const userRole = this.getAuthenticatedUser.user_type;
        const allowedRoles = [
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "HOSPITAL_PHYSICIAN",
          "LAB_ADMIN",
          "LAB_MANAGER",
          "LAB_DATA_ASSISTANT",
          "LAB_SUPER_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_DATA_ADMIN",
        ];
        if (allowedRoles.includes(userRole)) {
          if (
            this.checkNewReport(row) &&
            (row.is_critical || row.is_abnormal)
          ) {
            return "highlight-generated";
          } else if (row.is_critical || row.is_abnormal) {
            return "highlight-viewed"; // If both are true, use this class
          } else if (this.checkNewReport(row)) {
            return "finalized-case";
          }
        }
      }
      return "";
    },
    gotoPatientResultsTrendClinicalChemistry(patient) {
      if (patient && patient.internal_patient_id) {
        const patientResultsUrl = process.env.VUE_APP_PATIENT_TREND_RESULTS;
        const patientID = patient.internal_patient_id;
        let url;
        if (this.isOrderingPhysician) {
          let physicianId = this.getAuthenticatedUser._id;
          url = `${patientResultsUrl}/patient-results/blood-results/${patientID}?physician_id=${physicianId}`;
        } else {
          url = `${patientResultsUrl}/patient-results/blood-results/${patientID}`;
        }
        window.open(url, "_blank");
      }
    },
    gotoPatientResultsTrendToxiclogy(patient) {
      if (patient && patient.internal_patient_id) {
        const patientResultsUrl = process.env.VUE_APP_PATIENT_TREND_RESULTS;
        const patientID = patient.internal_patient_id;
        let url;
        if (this.isOrderingPhysician) {
          let physicianId = this.getAuthenticatedUser._id;
          url = `${patientResultsUrl}/patient-results/toxicology-results/${patientID}?physician_id=${physicianId}`;
        } else {
          url = `${patientResultsUrl}/patient-results/toxicology-results/${patientID}`;
        }
        window.open(url, "_blank");
      }
    },
    reOrderCase() {
      this.$router.push({
        name: "Re-Order",
        params: { order_id: this.reOrderId },
        query: {
          ...this.$route.query,
          testInfo: this.reOrderWithTestInfo,
          insurance: this.reOrderWithInsurance,
          address: this.reOrderWithAddress,
          redirectRoute: this.$route.name,
        },
      });
    },
    handleClose() {
      this.reOrderWithTestInfo = "";
      this.regenerateOrder = false;
      this.reOrderWithAddress = "";
      this.reOrderWithInsurance = "";
    },
    reOrder(orderId) {
      this.reOrderId = orderId;
      this.regenerateOrder = true;
    },
    handleVersioning() {
      const currentVersion = config.APP_VERSION;
      const currentAppName = config.APP_NAME;
      const versionKey = "APP_VERSION";
      const appName = "APP_NAME";
      if (localStorage.getItem(versionKey) !== currentVersion) {
        localStorage.clear();
        localStorage.setItem(versionKey, currentVersion);
        localStorage.setItem(appName, currentAppName);
        window.location.reload(true);
      }
    },
    initializeSearchOptions() {
      this.searchOptions = [...this.searchOptions];
      this.filterSearchOptions();
    },
    filterSearchOptions() {
      if (this.isPhysicianUser) {
        // Remove options for facility users
        const optionsToRemove = [
          "test_performed_by",
          "emr",
          "ordering_physician",
          "Sendout",
          "billing_sub_status",
        ];
        this.searchOptions = this.searchOptions.filter(
          (option) => !optionsToRemove.includes(option.value)
        );
      }
      if (this.isHospitalUser) {
        const optionsToRemove = [
          "test_performed_by",
          "emr",
          "Sendout",
          "billing_sub_status",
        ];
        this.searchOptions = this.searchOptions.filter(
          (option) => !optionsToRemove.includes(option.value)
        );
      }
      if (this.isLabTechnologistUser || this.isLabAssistantUser) {
        const optionsToRemove = ["hospital_marketers", "billing_sub_status"];
        this.searchOptions = this.searchOptions.filter(
          (option) => !optionsToRemove.includes(option.value)
        );
      }
    },
    viewEMR(orderId) {
      this.$router.push({
        name: "View-Case-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchAllPhysicians(query);
      }
    },
    async moveToValidations(validation) {
      this.requestValidationCase = validation;
      this.takeValidationReasonDialog = true;
    },
    sendParameter(row) {
      if (row.order_id) {
        this.goToOrderView(row.order);
      }
    },
    goToOrderView(order_id) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: order_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    async moveToValidation(reason) {
      try {
        this.loading = true;
        let params = {
          id: this.requestValidationCase,
          status: true,
          validation_reason: reason,
        };
        await this.$store.dispatch("cases/changeCaseValidationStatus", params);
        if (this.getUpdateValidationStatus) {
          successNotification("Case moved to validation Cases");
          await this.fetchAllCases();
        } else {
          errorNotification("Error while moving case to validation cases");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    timeDifference(time) {
      if (time && time.created_at) {
        let createdTime = time.created_at.split("T")[1].split(".")[0];
        let currentTime = new Date();
        let utcTime = currentTime.toISOString();
        let actualUtcTime = utcTime.split("T")[1].split(".")[0];
        let time1 = new Date(`1970-01-01T${createdTime}`);
        let time2 = new Date(`1970-01-01T${actualUtcTime}`);
        let diff = new Date(time2 - time1);
        let UTC = diff.toISOString();
        let UTCtime = UTC.split("T")[1].split(".")[0];
        let minutes = UTCtime.split(":");
        let minutesSeconds = minutes[1] + ":" + minutes[2];
        return minutesSeconds;
      }
    },
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
    async sentToLabdaq(caseId) {
      this.loading = true;
      try {
        let params = {
          case_id: caseId,
        };
        await this.$store.dispatch("cases/sendAccessionToLabdaq", params);
        if (this.getSendAccessionToLabdaq) {
          successNotification("Order sent to LABDAQ successfully");
          this.fetchAllCases();
        } else if (
          this.getSendToLabdaqValiationError &&
          this.getSendToLabdaqValiationError.error_code &&
          (this.getSendToLabdaqValiationError.error_code ===
            "ORDER_CODE_NOT_FOUND" ||
            this.getSendToLabdaqValiationError.error_code ===
              "TESTS_NOT_MATCHED" ||
            this.getSendToLabdaqValiationError.error_code ===
              "LABDAQ_ORDERIG_FACILITY_NOT_FOUND")
        ) {
          this.messageData = this.getSendToLabdaqValiationError.message;

          this.testDetailsData = this.getSendToLabdaqValiationError.errors
            .map((e) => e)
            .join(", ");
          this.errorMessage = true;
        } else {
          errorNotification("Error while sending order to LABDAQ");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async syncLabdaqReports(caseId) {
      try {
        this.loading = true;
        let params = {
          case_id: caseId,
        };
        await this.$store.dispatch("cases/synsAccessionToLabdaq", params);
        if (this.getSyncAccessionToLabdaq) {
          successNotification("Reports sync successfully");
          await this.fetchAllCases();
        } else {
          errorNotification("Report not synced.");
          await this.fetchAllCases();
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async testReportsDownloadLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsDownloadLog", params);
    },
    async testReportsViewLog(report, testReports) {
      let params = {
        case_id: report._id,
        report_id: testReports._id,
      };
      await this.$store.dispatch("cases/testReportsViewLog", params);
    },
    checkSendOutDisable(report) {
      let caseType = report.is_sendout;
      if (caseType == true) {
        return true;
      } else {
        return false;
      }
    },
    async onReportsExport() {
      this.loading = true;

      this.exportReportsDialogVisisble = true;
      this.loading = false;
    },
    async changeStatus(command, caseData, index) {
      if (command === "NOT_TO_CALL") {
        return;
      }
      try {
        if (command == caseData.status) {
          return;
        }
        this.takeStatusChangeReasonDialogTitle = command;

        let params = {
          status: command,
          id: caseData._id,
        };

        this.emrOrderId = caseData?.emr_order;
        this.hospitalName = caseData?.hospital?.name;

        if (caseData.status == "COMPLETE" || command == "COMPLETE") {
          this.unsetCompleteStatusChangeCase = caseData._id;
          this.toStatus = command;
          this.caseIndex = index;
          this.askReasonOnUnsetCompletedStatus();
        } else if (
          (caseData.status == "ACTIVE" || caseData.status == "REJECTED") &&
          command != "TEST_REPORTS" &&
          command != "COMPLETE"
        ) {
          this.unsetCompleteStatusChangeCase = caseData._id;
          this.toStatus = command;
          this.caseIndex = index;

          this.askReasonOnUnsetStatus();
        } else {
          await this.updateStatus(params, index);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async unsetCaseMovingStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      await this.updateStatus(params, this.caseIndex);
      if (
        this.toStatus == "REJECTED" &&
        this.hospitalName.trim() == "ADVANCED INTERNAL MEDICINE"
      ) {
        let params = {
          case_id: this.unsetCompleteStatusChangeCase,
          emr_order_id: this.emrOrderId,
          message: data.notes,
        };
        await this.sendRejection(params);
      }
    },
    async unsetCaseCompleteStatus(reason) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        reason,
      };

      await this.updateStatus(params, this.caseIndex);
    },
    async askReasonOnUnsetStatus() {
      this.takeStatusMovingReasonDialog = true;
    },
    async askReasonOnUnsetCompletedStatus() {
      this.takeStatusChangeReasonDialog = true;
      this.takeStatusChangeReasonDialogTitle =
        "Reason for moving from Complete to " +
        this.toStatus
          .split("_")
          .map((e) => this.capitalize(e))
          .join(" ");
    },
    async updateStatus(params, index) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/changeCaseStatus", params, {
          root: true,
        });
        this.loading = false;
        if (this.getUpdateCaseStatus && this.getUpdateCaseStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseStatus.message,
          });
          this.fetchAllCases();
          this.getAllCases.data[index].status = params.status;
          this.selectedCaseForBilling = null;
          this.patientSSN = "";
          this.patientRelationship = "";
          this.showBillingDetailsForm = false;
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async sendRejection(params) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "cases/practiceFusionRejectionMessage",
          params
        );
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    clearSearchBy() {
      if (this.$route.query.selectedSearchBy == "Sendout") {
        this.fetchAllCases(1);
      }

      if (this.$route.query.selectedSearchBy == "inhouse") {
        this.fetchAllCases(1);
      }
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType ||
        this.test_info.length ||
        this.emr ||
        this.patient_name ||
        this.search_string ||
        this.accession_id ||
        this.test_performed_by ||
        this.hospital_marketer.length ||
        this.patient_name ||
        this.billing_sub_status ||
        this.priority ||
        this.fromDate ||
        this.toDate
      ) {
        this.hospital = "";
        this.test_performed_by = "";
        this.hospital_marketer = [];
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.test_info = [];
        this.emr = "";
        this.patient_name = "";
        this.search_string = "";
        this.accession_id = "";
        this.patient_name = "";
        this.billing_sub_status = "";
        (this.priority = ""),
          (this.fromDate = ""),
          (this.toDate = ""),
          (this.page = 1);

        this.fetchAllCases(1);
      }
      if (this.searchBy == "Sendout") {
        this.fetchAllCases(1);
      }

      if (this.searchBy == "inhouse") {
        this.fetchAllCases(1);
      }
    },
    onSelectedDatesGenerateBarcodes() {
      if (
        this.barcode_receive_from_date != "" &&
        this.barcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleBarcodes",
          path: "multiple-barcodes",
          query: {
            from_date: this.barcode_receive_from_date,
            to_date: this.barcode_receive_to_date,
          },
        });
        this.barcode_receive_from_date = "";
        this.barcode_receive_to_date = "";
        this.generateBarcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    onSelectedDatesGenerateQrcodes() {
      if (
        this.qrcode_receive_from_date != "" &&
        this.qrcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleQrcodes",
          path: "multiple-qrcodes",
          query: {
            from_date: this.qrcode_receive_from_date,
            to_date: this.qrcode_receive_to_date,
          },
        });
        this.qrcode_receive_from_date = "";
        this.qrcode_receive_to_date = "";
        this.generateQrcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    onSelectedDatesGenerateTestBarcodes() {
      if (
        this.test_barcode_receive_from_date != "" &&
        this.test_barcode_receive_to_date != ""
      ) {
        let urlData = this.$router.resolve({
          name: "MultipleTestBarcodes",
          path: "multiple-test-barcodes",
          query: {
            from_date: this.test_barcode_receive_from_date,
            to_date: this.test_barcode_receive_to_date,
          },
        });
        this.test_barcode_receive_from_date = "";
        this.test_barcode_receive_to_date = "";
        this.generateTestBarcodesDialogVisible = false;
        window.open(urlData.href, "_blank");
      }
    },
    async changeCovidStatus(command, id, index, prevStatus) {
      try {
        this.loading = true;
        if (command == prevStatus) {
          return;
        }
        let params = {
          status: command,
          id: id,
        };
        await this.$store.dispatch("cases/changeCaseCovidStatus", params, {
          root: true,
        });
        if (
          this.getUpdateCaseCovidStatus &&
          this.getUpdateCaseCovidStatus.success
        ) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseCovidStatus.message,
          });
          this.getAllCases.data[index].covid_status = command;
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    hadMaxLength(caseData) {
      return (
        caseData.case_types.indexOf("CLINICAL_CHEMISTRY") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1 ||
        caseData.case_types.indexOf("PAD_ALZHEIMERS") > -1
      );
    },
    hasCovid(caseData) {
      return (
        caseData.case_types.indexOf("COVID") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1
      );
    },
    hasBloodCaseType(caseData) {
      return caseData.case_types.indexOf("CLINICAL_CHEMISTRY") > -1;
    },
    async initData() {
      this.setQueryParamsData();
      await Promise.all([this.fetchAllCases()]);
    },

    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedPatientName) {
        this.patient_name = this.$route.query.selectedPatientName;
      }
      if (this.$route.query.selectedEMR) {
        this.emr = this.$route.query.selectedEMR;
      }
      if (this.$route.query.is_stat) {
        this.priority = this.$route.query.is_stat;
      }
      if (this.$route.query.fromDate) {
        this.fromDate = this.$route.query.fromDate;
      }
      if (this.$route.query.toDate) {
        this.toDate = this.$route.query.toDate;
      }
      if (this.$route.query.selectedAccessionId) {
        this.accession_id = this.$route.query.selectedAccessionId;
      }
      if (this.$route.query.selectedCase) {
        this.caseType = this.$route.query.selectedCase;
        this.fetchAllTestPanels();
      }
      if (
        this.$route.query.selectedTest &&
        Array.isArray(this.$route.query.selectedTest) &&
        this.$route.query.selectedTest.length
      ) {
        this.fetchAllTestPanels();
        this.test_info = this.$route.query.selectedTest;
      } else if (
        this.$route.query.selectedTest &&
        this.$route.query.selectedTest.length
      ) {
        this.fetchAllTestPanels();
        this.test_info = [this.$route.query.selectedTest];
      }
      if (this.$route.query.selectedTestReportsOpen) {
        this.dialogVisible =
          this.$route.query.selectedTestReportsOpen === "true" ? true : false;
      }
      if (this.$route.query.selectedCaseId) {
        this.selectedCaseId = this.$route.query.selectedCaseId;
      }

      if (this.$route.query.selectedCaseOrderBy) {
        this.orderBy = this.$route.query.selectedCaseOrderBy;
      }
      if (this.$route.query.selectedCaseOrderType) {
        this.orderType = this.$route.query.selectedCaseOrderType;
      }
      if (this.$route.query.selectedPhysician) {
        const savedQuery = localStorage.getItem("searchQueryPhysician");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllPhysicians(savedQuery);
        }
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        const savedQuery = localStorage.getItem("searchQueryFacility");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllHospitals(savedQuery);
        }
        this.hospital = this.$route.query.selectedHospital;
      }
      if (this.$route.query.selectedUser) {
        this.fetchAllUsers();
        this.test_performed_by = this.$route.query.selectedUser;
      }
      if (this.$route.query.selectedMarketer) {
        this.fetchAllUsers();
        this.hospital_marketer = this.$route.query.selectedMarketer;
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      this.searchBy = this.$route.query.selectedSearchBy;
      if (this.$route.query.selectedException) {
        this.billing_sub_status = this.$route.query.selectedException;
      }
    },
    async fetchAllPhysicians(physician) {
      this.physicianLoading = true;
      let params = {
        limit: 25,
      };
      if (physician) {
        params.search_string = physician;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physicianLoading = false;
    },
    async fetchAllHospitals(hospital) {
      this.hospitalLoading = true;
      let params = {
        limit: 25,
      };
      if (hospital) {
        params.search_string = hospital;
      }
      await this.$store.dispatch("hospitals/fetchAllHospitals", params);
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalLoading = false;
    },
    async fetchAllUsers() {
      this.userLoading = true;

      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        status: "ACTIVE",
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let usersForTestPerofmed = ["LAB_TECHNOLOGIST"];
        this.usersList = this.getAllUsers.data.filter((item) =>
          usersForTestPerofmed.includes(item.user_type)
        );
        let marketer = [
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
        ];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          marketer.includes(item.user_type)
        );
      }
      this.userLoading = false;
    },
    prepareParams() {
      this.pregnant = "";
      this.sendout = "";

      const params = {
        page: this.page,
        limit: this.pageSize,
        is_validation_purpose: false,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.emr) {
        params.emr = this.emr;
      }
      if (this.accession_id) {
        params.accession_id = this.accession_id;
      }
      if (this.patient_name) {
        params.patient_name = this.patient_name;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.fromDate) {
        params.from_date = this.fromDate;
      }
      if (this.toDate) {
        params.to_date = this.toDate;
      }
      if (this.priority == "Stat") {
        params.is_stat = true;
      }
      if (this.priority == "Routine") {
        params.is_stat = false;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.test_performed_by) {
        params.test_performed_by = this.test_performed_by;
      }
      if (this.hospital_marketer.length) {
        params.hospital_marketers = this.hospital_marketer;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.test_info.length) {
        params.tests_info = [].concat.apply([], this.test_info);
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.searchBy == "Pregnancy") {
        this.pregnant = true;
        params.pregnant = true;
      }
      if (this.searchBy == "Sendout") {
        this.sendout = true;
        params.is_sendout = true;
      }
      if (this.searchBy == "inhouse") {
        this.inhouse = true;
        params.is_inhouse = true;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      if (this.selectedReportStatus) {
        params.is_new_report = this.selectedReportStatus;
      }
      if (this.emr_not_sent) {
        params.emr_result_not_sent = this.emr_not_sent;
      }
      if (this.billing_sub_status) {
        params.billing_sub_status = this.billing_sub_status;
      }
      if (this.$route.path === "/all-cases/release-pending") {
        params.release = false;
      }
      if (this.$route.path === "/all-cases/new-reports") {
        params.release = true;
      }
      if (this.replaced_insurance) {
        params.replaced_insurance = this.replaced_insurance;
      }
      if (this.isGowthamUser) {
        params.is_old = true;
      }
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllCases();
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllCases();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllCases();
    },
    clearTest() {
      this.caseType = "";
      this.test_info = [];
      this.fetchAllCases();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllCases();
    },
    handleCurrentChangeCaseType(page) {
      this.page = page;
      this.test_info = [];
      this.fetchAllTestPanels();
      this.fetchAllCases();
    },
    handleTest(page) {
      this.page = page;
      this.fetchAllCases();
    },
    async fetchAllTestPanels() {
      await this.$store.dispatch("labTests/fetchAllLabTests", {
        get_all: true,
        case_type_code: this.caseType,
      });
      if (this.getAllLabTests) {
        this.testNames = [];
        for (let caseData of this.getAllLabTests) {
          this.testNames.push(caseData);
        }
        this.testIds = {};
        let uniqueObject = {};
        if (this.caseType == "TOXICOLOGY") {
          this.testNames = this.testNames.map((e) => {
            if (
              e.category_code == "SCREENING" ||
              e.category_code == "SCREENING_VALIDITY"
            ) {
              e.category = "SCREENING";
            } else if (
              e.category_code == "ETG_ETS" ||
              e.category_code == "ETG/ETS"
            ) {
              e.category = "ETG/ETS";
            } else {
              e.category = "CONFIRMATION";
            }
            return e;
          });
        }

        let categories = Array.from(
          new Set(this.testNames.map((e) => e.category))
        );

        this.testIds = categories.map((category) => {
          let tests = this.testNames
            .filter((t) => t.category == category)
            .map((e) => e._id);
          return {
            category,
            tests,
          };
        });
      } else {
        this.testNames = [];
        this.testIds = {};
      }
    },

    async fetchAllCases() {
      try {
        let params = this.prepareParams();
        this.loading = true;
        await this.$store.dispatch("cases/fetchAllCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData._id);
        }
      } else {
        this.selectedCaseIds = [];
      }
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: {
          ...this.$route.query,
          redirectRoute: this.$route.name,
          status: this.selectedStatuses,
        },
      });
    },
    async onRestore(id) {
      this.$confirm("Are you sure to Restore case?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.restoreCase(id);
      });
    },
    async restoreCase(caseId) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/restoreArchivedCase", caseId);
        if (this.getRestoreCaseStatus) {
          successNotification("Case restored Successfully");
          await this.fetchAllCases(1);
        } else {
          errorNotification("An Error occured while restoring.");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    goToConcurrentCase(emrQuery, caseId) {
      this.$router.push({
        name: "Concurrent-Case-Information-Update",
        params: { case_id: caseId },
        query: {
          ...this.$route.query,
          isEMR: emrQuery,
        },
      });
    },
    async onViewPriliminaryReports(report) {
      this.loading = true;
      let testReportsData = report.test_reports;
      for (let i = 0; i < testReportsData.length; i++) {
        await this.$store.dispatch("cases/generateTestReport", {
          accession_id: report.accession_id,
          case_type: report.case_type,
          report_id: testReportsData[i].report_id,
          test_results_id: testReportsData[i].test_results_id,
          result_file_id: testReportsData[i].result_file_id,
          skip_download: true,
        });
        if (testReportsData[i].is_priliminary_report) {
          let routerData = this.$router.resolve({
            name: "supplementaryReportView",
            params: {
              report_id: testReportsData[i]._id,
              case_id: report._id,
            },
          });
          window.open(routerData.href, "_blank");
        }
        await this.testReportsViewLog(report, testReportsData[i]);
        await this.testReportsDownloadLog(report, testReportsData[i]);
        this.initData();
      }
    },
    async onViewReports(report) {
      try {
        this.loading = true;
        let testReportsData = report.test_reports;

        for (let i = 0; i < testReportsData.length; i++) {
          await this.$store.dispatch("cases/generateTestReport", {
            accession_id: report.accession_id,
            case_type: report.case_type,
            report_id: testReportsData[i].report_id,
            test_results_id: testReportsData[i].test_results_id,
            result_file_id: testReportsData[i].result_file_id,
            skip_download: true,
          });
          if (
            (testReportsData[i].is_manually ||
              testReportsData[i].additional_report_merged ||
              testReportsData[i].additional_report_already_merged ||
              testReportsData[i].download_ready) &&
            testReportsData[i].mark_for_physician
          ) {
            let routerData = this.$router.resolve({
              name: "supplementaryReportView",
              params: {
                report_id: testReportsData[i]._id,
                case_id: report._id,
              },
            });
            window.open(routerData.href, "_blank");
            this.initData();
          } else {
            if (testReportsData[i].mark_for_physician) {
              let routerData = this.$router.resolve({
                name: "ResultFileTestReports",
                params: {
                  report_id: testReportsData[i]._id,
                  case_id: report._id,
                },
              });
              window.open(routerData.href, "_blank");
              this.initData();
            }
          }
          await this.testReportsViewLog(report, testReportsData[i]);
          await this.testReportsDownloadLog(report, testReportsData[i]);
          this.initData();
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    goToSendOutReports(testId) {
      this.$router.push({
        name: "SendOutsView",
        query: {
          case_id: testId,
        },
      });
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedTest: params.tests_info,
        selectedHospital: params.hospital,
        selectedUser: params.test_performed_by,
        selectedMarketer: params.hospital_marketers,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPatientName: params.patient_name,
        selectedEMR: params.emr,
        selectedAccessionId: params.accession_id,
        selectedPageSize: params.limit,
        selectedTestReportsOpen: this.$route.query.selectedTestReportsOpen,
        selectedCaseId: this.$route.query.selectedCaseId,
        selectedSearchBy: this.searchBy || undefined,
        selectedCaseOrderBy: params.order_by,
        selectedCaseOrderType: params.order_type,
        is_stat: this.priority,
        fromDate: params.fromDate,
        toDate: params.toDate,
        selectedException: params.billing_sub_status,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },

    onPrintBarCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleBarcodes",
        path: "multiple-barcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onPrintQrCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleQrcodes",
        path: "multiple-qrcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onPrintTestBarCodes() {
      let urlData = this.$router.resolve({
        name: "MultipleTestBarcodes",
        path: "multiple-test-barcodes",
        query: {
          case_ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onDelete(id) {
      this.requestArchiveCase = id;
      this.takeReasonDialog = true;
    },
    async deleteCase(reason) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/deleteCase", {
          case_id: this.requestArchiveCase,
          reason: reason,
        });
        if (this.getCaseDeleteStatus) {
          successNotification("Case archived successfully");
          this.requestArchiveCase = "";
          await this.fetchAllCases();
        } else {
          errorNotification(
            this.getCaseDeleteError || "Error while deleting case"
          );
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  watch: {
    "$route.query.selectedString": {
      immediate: true,
      handler: function () {
        this.updateShowToxColumn();
        this.updateCovidColumn();
        this.updateResultColumn();
      },
    },
  },
};
</script>

<style lang="scss">
.test-reports {
  display: flex;
  align-items: center;
  padding: 4px 5px;

  .regular-reports {
    &.single-report {
      margin-left: 20px;
    }

    h5 {
      color: #0a5da6;
      font-size: 14px;

      span {
        color: #bdbdbd;
      }
    }
  }

  .repots {
    h5 {
      color: #0a5da6;
    }
  }
}

.left-dropdown {
  text-align: left;
}

.test-tabs {
  padding: 0;

  .el-tabs__active-bar {
    height: 3px;
    background-color: #0a5da6;
    border-radius: 25px;
  }

  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 600;
  }

  .el-tabs__item {
    color: #828282;
  }

  .el-tabs__nav-scroll {
    padding: 0 18px;
  }

  .types {
    padding: 0 5px;

    .case-type {
      &.view-reports-dialog {
        .el-button {
          width: 100%;
          min-height: 36px;
          padding: 0 17px;
          background-color: #f2f6f9;
          border: 1px dashed #bababc;

          span {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              margin-right: 6px;
            }

            p {
              margin-left: 8px;
              color: #828282;
            }
          }
        }
      }

      .el-input__inner {
        height: 36px;
        border: 1px solid rgba(86, 204, 242, 0.8);
      }
    }

    .btn {
      margin-top: 23px;

      .el-button {
        min-height: 36px;
        padding: 8px 24px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 7px;
      }
    }
  }

  .mark {
    margin-left: 15px;
  }

  .panel {
    .documents {
      display: none;
    }

    .el-table__header {
      color: rgba(0, 0, 0, 0.8);
      border-spacing: 0 5.5px;
      border-radius: 25px;
    }

    .el-table {
      background: rgb(238, 242, 245);

      .el-table__cell {
        padding: 5px 0;
      }

      .el-table__header-wrapper {
        border-radius: 10px;
      }

      .el-table__body-wrapper {
        border-radius: 6px;
      }

      .el-table__cell {
        .cell {
          font-weight: 500;
        }
      }
    }

    .el-table thead {
      color: rgba(0, 0, 0, 0.8);
    }

    .physician-btn {
      .el-switch .el-switch__core {
        width: 34px !important;
        height: 15px;
        background-color: #0a5da6;
        border: none;

        .el-switch__action {
          top: 3px;
          left: 2px;
          width: 9px;
          height: 9px;
        }
      }

      .el-switch__label.is-active {
        color: #0a5da6;
      }

      .el-switch.is-checked {
        .el-switch__core {
          width: 34px !important;
          height: 15px;
          background-color: #4bb543 !important;
          border: none;
        }

        .el-switch__action {
          top: 2.2px;
          left: 38.5px;
          width: 10px;
          height: 10px;
        }
      }
    }

    .title {
      color: #2f80ed;

      img {
        color: #eb5757;
        vertical-align: middle;
      }
    }
  }

  .action-test-icons {
    display: flex;

    li {
      margin-right: 10px;

      .el-button {
        min-height: auto;
        padding: 0;
        background: none;
        border: none;
        transition: all 0.2s;

        &:hover {
          background-color: #eef2f5;
        }

        &:active {
          background-color: #eef2f5;
        }

        &:focus {
          background-color: #eef2f5;
        }

        img {
          color: red;

          &:hover {
            color: #0a5da6;
          }
        }
      }
    }
  }
}

.documents {
  padding: 0 20px;

  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 500;
  }

  .el-tabs__active-bar {
    background-color: #0a5da6;
    border-radius: 25px;
  }

  .document-container {
    display: grid;
    align-items: center;

    gap: 10px;
    grid-template-columns: 230px 230px;
  }

  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 75% 8% 10%;

    img {
      width: 18px;
      height: 18px;
    }

    .cancel {
      width: 15px;
      height: 15px;
    }

    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 500;
    }

    .demo-progress {
      .el-progress--line {
        width: 230px;

        .el-progress-bar__outer {
          height: 5px !important;
          background-color: #9ae0f7;
        }

        .el-progress-bar__inner {
          height: 5px;
          background-color: #2d9cdb;
        }
      }

      .el-progress__text {
        color: #828282;
      }
    }
  }

  .document-cell {
    display: grid;
    align-items: center;
    padding: 0 0.3rem;
    background-color: #fff;
    border: 1px solid #56ccf2;
    border-radius: 7px;

    grid-template-columns: 9% 80% 8% 10%;

    img {
      width: 18px;
      height: 18px;
    }

    .cancel {
      width: 15px;
      height: 15px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.listings-navbar {
  .barcode-print {
    .el-button--small {
      padding: 7px 15px;
      border-radius: 8px;

      &:hover {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }

      &:focus {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }

      &:active {
        color: #4f4f4f;
        background: #fff;
        box-shadow: none;
        border: 1px solid #dedbdb;
      }
    }
  }
}

.btn-synced {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}

.btn-sync {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #5162fd;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #5162fd;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
}

.btn-processing {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #f28b0c;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #f28b0c;
  border-radius: 4px !important;

  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #f28b0c;
    color: #f28b0c;
  }
}

.el-badge__content.is-fixed {
  font-size: 12px;
  line-height: 18px;
  position: absolute;
  background: #273480;
  top: 3px;
  height: 16px;
  right: calc(-5px + var(--el-badge-size) / 2);
  transform: translateY(-50%) translateX(100%);
}

.validation-button {
  display: block;
  margin-bottom: -5px;

  img {
    width: 25px;
  }
}

.reorder-radio {
  .el-radio-group {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;

    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #0a5da6;
    }
  }
}
</style>
